<template>
  <div>
    <div class="intro-y flex items-center h-10">
      <h2 class="text-lg font-medium truncate mr-3">Courts' Locations</h2>
      <MapIcon class="report-box__icon text-theme-1" />
      <!-- <div
        class="sm:ml-auto mt-3 sm:mt-0 relative text-gray-700 dark:text-gray-300"
      >
        <MapPinIcon
          class="w-4 h-4 z-10 absolute my-auto inset-y-0 ml-3 left-0"
        />
        <input
          type="text"
          class="input w-full sm:w-40 box pl-10"
          placeholder="Filter by State"
        />
      </div> -->
    </div>
    <div class="intro-y box p-5 mt-3">
      <div>
        {{ courts.length }} courts across 36 states and FCT, click the marker to
        see location details.
      </div>
      <ReportMap class="report-maps mt-5 bg-gray-200 rounded-md" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ReportMap from "./ReportMap.vue";

export default {
  components: {
    ReportMap
  },
  data() {
    return {
      courts: []
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    }
  },
  mounted() {
    this.getCourts();
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.getCourts();
      }
    }
  },
  methods: {
    getCourts() {
      axios
        .get(`${window.host}/api/courts-params`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.courts = response.data;
          }
        });
    }
  }
};
</script>
